import { HOST_TOOL_NAMES } from "../../turns/turn-constants";

export const SOFT_FAIL_BROWSER_TOOLS = new Set<string>([
  HOST_TOOL_NAMES.BROWSER_NAVIGATE,
  HOST_TOOL_NAMES.BROWSER_SNAPSHOT,
  HOST_TOOL_NAMES.BROWSER_ACT,
  HOST_TOOL_NAMES.BROWSER_WAIT,
  HOST_TOOL_NAMES.BROWSER_INSPECT,
  HOST_TOOL_NAMES.BROWSER_SCREENSHOT,
  HOST_TOOL_NAMES.BROWSER_RECORD_START,
  HOST_TOOL_NAMES.BROWSER_RECORD_STOP,
  HOST_TOOL_NAMES.BROWSER_CLOSE,
  HOST_TOOL_NAMES.REPL_EVAL,
  HOST_TOOL_NAMES.REPL_RESET,
]);
